import React, { useEffect, useState } from "react";
import { Button, Modal, Icon, Text } from "@telia/teddy";
import { useDispatch } from "react-redux";
import LoadingPebble from "../../../../components/components/styleguide/LoadingPebble/LoadingPebble";
import SummaryContinueButton from "../../organisms/SummaryContinueButton/SummaryContinueButton";
import { closeDelayOnPurchaseModal } from "../../../state/actions/paymentActions";
import "./DelayOnPurchaseModal.less";

interface Props {
    open: boolean;
    minDelayInSeconds?: number;
    maxDelayInSeconds?: number;
}

export const useCountdownTimer = (seconds: number) => {
    const [timeRemaining, setTimeRemaining] = useState(seconds);

    useEffect(() => {
        const timerInterval = setInterval(() => {
            setTimeRemaining((prevTime) => {
                if (prevTime <= 0) {
                    clearInterval(timerInterval);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        // Cleanup the interval when the component unmounts
        return () => clearInterval(timerInterval);
    }, []);

    if (!timeRemaining) {
        return;
    }

    return timeRemaining;
};

const DelayOnPurchaseModal: React.FC<Props> = ({ open, minDelayInSeconds, maxDelayInSeconds }) => {
    const dispatch = useDispatch();
    const min = minDelayInSeconds ?? 0;
    const max = maxDelayInSeconds ?? min;
    const delaySeconds = max > min ? min + Math.floor(Math.random() * (max - min + 1)) : min;
    const timeRemaining = useCountdownTimer(delaySeconds);

    return (
        <Modal
            onOpenChange={(isOpen) => {
                if (!isOpen) {
                    dispatch(closeDelayOnPurchaseModal());
                }
            }}
            open={open}
        >
            <Modal.Content className="delay-on-purchase-modal__content">
                <Modal.Close aria-label="lukk" slot="floating" />
                <Modal.Group position="relative">
                    <Modal.Title mt="150" as="h3" position="relative">
                        Det er for tiden stor pågang
                    </Modal.Title>
                </Modal.Group>
                <Modal.Group justify="center" align="center" mt="400">
                    <div className="delay-on-purchase-modal__content-container">
                        {timeRemaining ? (
                            <>
                                <LoadingPebble className="delay-on-purchase-modal__loading-pebble" />
                                <Text mb="100">Vennligst bli værende på siden...</Text>
                            </>
                        ) : (
                            <>
                                <Icon name="check-circle" className="delay-on-purchase-modal__checkmark-icon" />
                                <Text mb="100">Du kan nå fortsette</Text>
                            </>
                        )}
                    </div>
                </Modal.Group>
                <Modal.Group variant="action" position="relative" justify="center" align="center">
                    {timeRemaining ? (
                        <Button variant="primary" size="md" disabled={!!timeRemaining}>
                            Fortsett om {timeRemaining} sekunder
                        </Button>
                    ) : (
                        <SummaryContinueButton hasSeenDelayOnPurchaseModal={true} />
                    )}
                </Modal.Group>
            </Modal.Content>
        </Modal>
    );
};

export default DelayOnPurchaseModal;
